// Shared Web Audio plumbing for both one-shot SFX (sound.js) and looping
// background music (music.js) — a single AudioContext instance, and the
// oscillator+gain tone-generation helper both build on. Degrades to a
// silent no-op if AudioContext isn't available (older browsers, vitest's
// `node` test environment), same contract as sound.js's original design.

let audioCtx = null;

export function getAudioContext() {
  if (typeof window === "undefined") return null;
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  if (!audioCtx) {
    audioCtx = new Ctx();
  }
  if (audioCtx.state === "suspended") {
    audioCtx.resume().catch(() => {});
  }
  return audioCtx;
}

export function tone(ctx, { freq, start, duration, type = "square", gain = 0.15 }) {
  const osc = ctx.createOscillator();
  const g = ctx.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, start);
  g.gain.setValueAtTime(0, start);
  g.gain.linearRampToValueAtTime(gain, start + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, start + duration);
  osc.connect(g);
  g.connect(ctx.destination);
  osc.start(start);
  osc.stop(start + duration + 0.02);
}
